<template>
  <!-- 稿件管理 -->
  <div class="fillcontain">
    <head-top></head-top>
    <div class="table_container">
      <el-tabs v-model="mediaType" @tab-click="changeType">
        <el-tab-pane name="1" label="网络媒体">
          <span slot="label">
            网络媒体
            <i class="red" v-if="num_1 != 0">{{ num_1 }}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="2" label="自媒体">
          <span slot="label">
            自媒体
            <i class="red" v-if="num_2 != 0">{{ num_2 }}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="3" label="微信公众号">
          <span slot="label">
            微信公众号
            <i class="red" v-if="num_3 != 0">{{ num_3 }}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="4" label="微博">
          <span slot="label">
            微博
            <i class="red" v-if="num_4!= 0">{{ num_4 }}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="5" label="百科问答知识营销">
          <span slot="label">
            百科问答知识营销
            <i class="red" v-if="num_5 != 0">{{ num_5 }}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="6" label="朋友圈社群">
          <span slot="label">
            朋友圈社群
            <i class="red" v-if="num_6 != 0">{{ num_6 }}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="7" label="短视频">
          <span slot="label">
            短视频
            <i class="red" v-if="num_7 != 0">{{ num_7 }}</i>
          </span>
        </el-tab-pane>
      </el-tabs>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="全部" name="0">
          <span slot="label">
            全部
            <i class="red" v-if="state_0 != 0">{{ state_0 }}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="1">
          <span slot="label">
            待发布
            <i class="red" v-if="state_1 != 0">{{ state_1 }}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="2">
          <span slot="label">
            发布中
            <i class="red" v-if="state_2 != 0">{{ state_2 }}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="3">
          <span slot="label">已发布</span>
        </el-tab-pane>
        <el-tab-pane name="4">
          <span slot="label">
            申请退款
            <i class="red" v-if="state_4 != 0">{{ state_4 }}</i>
          </span>
        </el-tab-pane>
        <el-tab-pane name="6">
          <span slot="label">已撤稿</span>
        </el-tab-pane>
        <el-tab-pane name="7">
          <span slot="label">拒稿</span>
        </el-tab-pane>
      </el-tabs>
      <div class="media-cell" style="height: 60px; line-height: 50px">
        <div class="man-cell" style="width: 350px">
          <el-date-picker
            v-model="stime"
            type="daterange"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
        </div>
        <div class="man-cell">
          <el-input v-model="title" placeholder="文章标题："></el-input>
        </div>
        <div class="man-cell">
          <el-input v-model="name" placeholder="媒体名称："></el-input>
        </div>
        <el-button type="primary" @click="changeData()">搜索</el-button>
        <el-button
          type="info"
          :loading="downloadLoading"
          @click="onDaochu(stime[0], stime[1], title, name)"
        >导出Excel</el-button>
      </div>
      <el-table :data="tableData" highlight-current-row style="width: 100%" v-loading="loading">
        <el-table-column property="number" label="订单编号" width="80%"></el-table-column>
        <el-table-column property="title" :label="mediaType==3?'标题':'项目名称'">
          <template slot-scope="scope">
            <a
              v-if="scope.row.link != ''"
              style="color: #000000; cursor: pointer"
              :href="scope.row.link"
              target="_blank"
              rel="noopener noreferrer"
            >{{ scope.row.title }}</a>
            <a
              v-if="scope.row.link == '' && scope.row.file != ''"
              style="color: #000000; cursor: pointer"
              :href="scope.row.file"
            >{{ scope.row.title }}</a>
            <a
              v-if="scope.row.link == '' && scope.row.file == ''"
              style="color: #000000; cursor: pointer"
              @click="onLook(scope.row.id)"
            >{{ scope.row.title }}</a>
          </template>
        </el-table-column>
        <el-table-column property="remark" label="备注"></el-table-column>
        <el-table-column :label="showName()" width="100%">
          <template slot-scope="scope">
            <a>{{ scope.row.media }}{{scope.row.selfMedia?'-'+scope.row.portal:'' }}</a>
          </template>
        </el-table-column>
        <el-table-column v-if="mediaType==7" property="portals" label="视频平台" width="95%"></el-table-column>
        <!-- <el-table-column v-if="mediaType==5" property="channel" label="任务类型" width="80%"></el-table-column> -->
        <el-table-column v-if="mediaType==6" property="channel" label="推广类型" width="80%"></el-table-column>
        <el-table-column label="执行方式" v-if="mediaType!=1&&mediaType!=2&&mediaType!=5">
          <template slot-scope="scope">
            <a v-if="scope.row.priceType=='topPrice'">{{mediaType==3?'头条价':'首发价'}}</a>
            <a v-else-if="scope.row.priceType=='forwardPrice'">转发价</a>
            <a v-else-if="scope.row.priceType=='taskPrice'">微任务价</a>
            <a v-else-if="scope.row.priceType=='normalPrice'">普发价</a>
            <a v-else-if="scope.row.priceType=='originalPrice'">原创价</a>
            <a v-else-if="scope.row.priceType=='livePrice'">直播价</a>
            <!--  -->
          </template>
        </el-table-column>
        <el-table-column
          property="channel"
          label="业务类型"
          v-if="mediaType==1||mediaType==2||mediaType==5"
        ></el-table-column>
        <el-table-column property="price" label="价格" width="80%">
          <template slot-scope="scope">
            <a>{{ scope.row.price + scope.row.addPrice }}</a>
          </template>
        </el-table-column>
        <el-table-column property="state" label="发布状态" width="80%"></el-table-column>
        <el-table-column label="发布回执" width="80%">
          <template slot-scope="scope">
            <a
              v-if="scope.row.mediaType==6"
              :style="scope.row.read?'color: #000000':'color: #FD5353'"
              v-show="scope.row.publishLink != ''"
              @click="onRead(scope.row.id,scope.row)"
            >查看</a>
            <a
              v-else
              :style="scope.row.read?'color: #000000':'color: #FD5353'"
              v-show="scope.row.publishLink != ''"
              :href="scope.row.publishLink"
              target="_blank"
              rel="noopener noreferrer"
              @click="onRead(scope.row.id,scope.row)"
            >查看</a>
          </template>
        </el-table-column>
        <!-- <el-table-column label="媒体类型" width="80%">
          <template slot-scope="scope">
            <a v-if="scope.row.mediaType==1">媒体</a>
            <a v-else-if="scope.row.mediaType==2">自媒体</a>
            <a v-else-if="scope.row.mediaType==3">微信公众号</a>
            <a v-else-if="scope.row.mediaType==4">微博</a>
            <a v-else-if="scope.row.mediaType==5">百科</a>
            <a v-else-if="scope.row.mediaType==6">朋友圈社群</a>
            <a v-else-if="scope.row.mediaType==7">短视频</a>
          </template>
        </el-table-column>-->
        <el-table-column property="createTime" label="创建时间" width="80%"></el-table-column>
        <el-table-column property="publishTime" label="发布时间" width="80%"></el-table-column>
        <el-table-column property="withdrawTime" label="撤稿时间" width="80%"></el-table-column>
        <!-- <el-table-column property="personalReamrk" label="会员备注" width="80%"></el-table-column> -->
        <el-table-column label="操作" width="90%">
          <template slot-scope="scope">
            <a
              style="cursor: pointer; color: #fd5353"
              v-if="scope.row.refuseReason"
              v-show="
                scope.row.state == '已发布' || scope.row.state == '发布中'
              "
              @click="tuikuanyuanyin(scope.row.refuseReason)"
            >拒绝原因</a>
            <a
              style="cursor: pointer; color: #fd5353"
              v-if="scope.row.reason"
              v-show="scope.row.state == '拒稿'"
              @click="tuikuanyuanyin2(scope.row.reason)"
            >拒绝原因</a>
            <el-button
              size="mini"
              type="danger"
              style="float: left"
              v-show="
                scope.row.state == '待发布' ||
                scope.row.state == '发布中' ||
                scope.row.state == '已发布'
              "
              @click="
                dialogVisible2 = true;
                reasonid = scope.row.id;
              "
            >退款</el-button>
            <el-button
              size="mini"
              style="float: left; margin: 0; margin-top: 10px"
              v-show="scope.row.state == '已发布'"
              @click="handleDetail(scope.$index, scope.row)"
            >修改</el-button>
            <el-button
              size="mini"
              style="float: left; margin: 0; margin-top: 10px"
              @click="reAdd(scope.row)"
            >再次发布</el-button>
          </template>
        </el-table-column>
        <el-table-column property="personalReamrk" label="会员备注"></el-table-column>
      </el-table>
      <div class="Pagination" style="text-align: left; margin-top: 10px">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="index"
          :page-size="20"
          layout="total, prev, pager, next"
          :total="count"
        ></el-pagination>
      </div>
    </div>
    <el-dialog title="稿件详情" :visible.sync="dialogVisible" width="40%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="修改说明：" style="clear: both">
          <el-input style="width: 80%" type="textarea" size="small" v-model="content"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sumbit_question">确定修改</el-button>
        <!-- <el-button type="danger" @click="sumbit_refund">申请退款</el-button>
        <el-button type="warning" @click="sumbit_finish">确定完成</el-button>-->
      </span>
    </el-dialog>
    <el-dialog title="退款原因" :visible.sync="dialogVisible2" width="40%">
      <el-form ref="form" label-width="100px">
        <el-form-item label="退款原因" style="clear: both">
          <el-input style="width: 80%" type="textarea" size="small" v-model="reason"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible3 = true">确定退款</el-button>
      </span>
    </el-dialog>
    <el-dialog title="是否确认退款" :visible.sync="dialogVisible3" width="40%">
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible3 = false">取 消</el-button>
        <el-button type="primary" @click="sumbit_refund(reasonid)">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="图片" :visible.sync="dialogVisible4" width="40%">
      <img v-for="(img,i) in imgs" :key="i" style="height:160px;width:160px" :src="img" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible4 = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import HeadTop from "../components/HeadTop";
import myAxios from "../myAxios";
import axios from "axios";
export default {
  inject: ["reload"],
  watch: {
    $route(to, from) {
      // 路由发生变化页面刷新
      this.reload();
    }
  },
  data() {
    return {
      num_1: 0,
      num_2: 0,
      num_3: 0,
      num_4: 0,
      num_5: 0,
      num_6: 0,
      num_7: 0,
      state_0: 0,
      state_1: 0,
      state_2: 0,
      state_4: 0,
      numList: [],
      reasonid: "",
      reason: "",
      state: 0,
      downloadLoading: false,
      excelData: [],
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      mediaType: "1",
      activeName: "0",
      dialogVisible: false, //弹窗开关
      username: localStorage.getItem("username"),
      tableData: [], //用户列表数据
      index: 1, //页码
      size: 20, //页大小
      count: 0, //数据总数
      loading: false, //加载状态
      detail: [],
      content: "",
      imgs: [],
      stime: ["", ""],
      otime: "",
      title: "",
      name: "",
      tabs: []
    };
  },
  components: {
    HeadTop
  },
  created() {
    this.initData();
    this.getNum();
  },
  methods: {
    getNum() {
      if (sessionStorage.getItem("countData2")) {
        var res = JSON.parse(sessionStorage.getItem("countData2"));
        console.log("Res", res);
        this.numList = res.data;
        this.showNum();
        if (res.data.media) this.num_1 = res.data.media.state_0;
        if (res.data.self) this.num_2 = res.data.self.state_0;
        if (res.data.official) this.num_3 = res.data.official.state_0;
        if (res.data.blog) this.num_4 = res.data.blog.state_0;
        if (res.data.baike) this.num_5 = res.data.baike.state_0;
        if (res.data.wechat) this.num_6 = res.data.wechat.state_0;
        if (res.data.tiktok) this.num_7 = res.data.tiktok.state_0;
      }
    },
    showName() {
      if (this.mediaType == 4) {
        return "微博名称";
      } else if (this.mediaType == 5) {
        return "业务名称";
      } else if (this.mediaType == 3) {
        return "微信公众号名称";
      } else if (this.mediaType == 7) {
        return "账号名称";
      }
      return "媒体名称";
    },
    onRead(id, item) {
      console.log(item);
      if (item.mediaType == 6) {
        this.imgs = item.imgs;
        this.dialogVisible4 = true;
      }

      myAxios.post(`/client_user/OrderLinkRead/v1?orderId=${id}`).then(res => {
        item.read = true;
      });
    },
    onLook(id) {
      let newpage = this.$router.resolve({
        name: "look2",
        query: {
          id: id,
          name: this.username,
          index: this.index
        }
      });
      window.open(newpage.href, "_blank");
    },
    // 导出excle
    onDaochu(time1, time2, title, name) {
      if (this.downloadLoading) {
        this.$message({
          type: "info",
          message: "数据较多，正在加载中。稍后再试"
        });
        return;
      }
      this.downloadLoading = true;
      myAxios
        .get(
          `/client_login/OrderListExport/v1?username=${this.username}&state=${this.state}&title=${title}&media=${name}&startTime=${time1}&endTime=${time2}&mediaType=${this.mediaType}`
        )
        .then(res => {
          this.downloadLoading = false;
          const link = document.createElement('a');
          link.href = res.data;
          link.setAttribute('download', "导出数据");
          document.body.appendChild(link);
          link.click();
        });
    },
    Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../assets/js/Export2Excel");
        const tHeader = [
          "订单号",
          "稿件标题",
          "价格",
          "发布链接",
          "出稿状态",
          "发布媒体",
          "自媒体号",
          "发布时间",
          "撤稿时间",
          "创建时间"
        ];
        const filterVal = [
          "id",
          "title",
          "prices",
          "publishLink",
          "state",
          "media",
          "portal",
          "createTime",
          "withdrawTime",
          "publishTime"
        ];
        var datas = this.excelData;
        console.log(datas);
        for (var i = 0; i < datas.length; i++) {
          datas[i].prices = datas[i].price + datas[i].addPrice;
        }
        const list = datas;
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, "列表excel");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    sumbit_question() {
      let data = {
        username: this.detail.username,
        orderId: this.detail.id,
        content: this.content
      };
      myAxios.post(`/client_user/SubmitQuestion/v1`, data).then(res => {
        if (res.code == 0) {
          this.$alert(res.data, "提示", {
            confirmButtonText: "确定"
          }).then(() => {
            this.dialogVisible = false;
            this.$parent.$parent.$parent.getNums();
            setTimeout(() => {
              this.getNum();
            }, 1000);
          });
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定"
          });
        }
      });
    },
    reAdd(row) {
      console.log(row);
      localStorage.setItem("remediaType", row.mediaType);
      localStorage.setItem("link", row.link);
      localStorage.setItem("title", row.title);
      localStorage.setItem("content", row.content);
      localStorage.setItem("remark", row.remark);
      setTimeout(() => {
        this.$router.push({
          path: "/addArticle"
        });
      }, 100);
    },
    handleDetail(index, row) {
      console.log(index, row);
      this.dialogVisible = true;
      this.detail = row;
    },
    async initData() {
      try {
        this.getUsers();
      } catch (err) {
        console.log("获取数据失败", err);
      }
    },
    handleCurrentChange(val) {
      this.index = val;
      this.changeData();
    },
    async getUsers() {
      myAxios
        .get(
          `/client_login/OrderList/v1?username=${this.username}&index=${this.index}&size=20&mediaType=${this.mediaType}`
        )
        .then(res => {
          this.tableData = res.data.orders;
          // this.tabs = res.data.orders;
          this.count = res.total;
          // this.$global_msg.num_1 =
          //   this.tabs.state_1 + this.tabs.state_2 + this.tabs.state_4;
        });
      this.loading = false;
    },
    showNum() {
      console.log("numList", this.numList);
      if (this.mediaType == "1" && this.numList.media) {
        this.state_0 = this.numList.media.state_0;
        this.state_1 = this.numList.media.state_1;
        this.state_2 = this.numList.media.state_2;
        this.state_4 = this.numList.media.state_4;
      } else if (this.mediaType == "2" && this.numList.self) {
        this.state_0 = this.numList.self.state_0;
        this.state_1 = this.numList.self.state_1;
        this.state_2 = this.numList.self.state_2;
        this.state_4 = this.numList.self.state_4;
      } else if (this.mediaType == "3" && this.numList.official) {
        this.state_0 = this.numList.official.state_0;
        this.state_1 = this.numList.official.state_1;
        this.state_2 = this.numList.official.state_2;
        this.state_4 = this.numList.official.state_4;
      } else if (this.mediaType == "4" && this.numList.blog) {
        this.state_0 = this.numList.blog.state_0;
        this.state_1 = this.numList.blog.state_1;
        this.state_2 = this.numList.blog.state_2;
        this.state_4 = this.numList.blog.state_4;
      } else if (this.mediaType == "5" && this.numList.baike) {
        this.state_0 = this.numList.baike.state_0;
        this.state_1 = this.numList.baike.state_1;
        this.state_2 = this.numList.baike.state_2;
        this.state_4 = this.numList.baike.state_4;
      } else if (this.mediaType == "6" && this.numList.wechat) {
        this.state_0 = this.numList.wechat.state_0;
        this.state_1 = this.numList.wechat.state_1;
        this.state_2 = this.numList.wechat.state_2;
        this.state_4 = this.numList.wechat.state_4;
      } else if (this.mediaType == "7" && this.numList.tiktok) {
        this.state_0 = this.numList.tiktok.state_0;
        this.state_1 = this.numList.tiktok.state_1;
        this.state_2 = this.numList.tiktok.state_2;
        this.state_4 = this.numList.tiktok.state_4;
      } else {
        this.state_0 = 0;
        this.state_1 = 0;
        this.state_2 = 0;
        this.state_4 = 0;
      }
    },
    changeType(tab, event) {
      this.mediaType = tab.name;
      this.changeData("", "", "", "");
      this.showNum();
    },
    handleClick(tab, event) {
      console.log(tab.name);
      this.state = tab.name;
      this.changeData("", "", "", "");
    },
    changeData() {
      var time1 = this.stime[0];
      var time2 = this.stime[1];
      var title = this.title.replace(/\s*/g, "");
      var name = this.name.replace(/\s*/g, "");
      myAxios
        .get(
          `/client_login/OrderList/v1?username=${this.username}&state=${this.state}&title=${title}&media=${name}&startTime=${time1}&endTime=${time2}&index=${this.index}&size=20&mediaType=${this.mediaType}`
        )
        .then(res => {
          this.tableData = res.data.orders;
          this.count = res.total;
          this.tabs = res.data;
          this.$global_msg.num_1 =
            this.tabs.state_1 + this.tabs.state_2 + this.tabs.state_4;
        });
      this.loading = false;
    },
    sumbit_refund(id) {
      if (this.reason == "") {
        this.dialogVisible3 = false;
        this.$alert("请填写退款原因", "提示", {});
      } else {
        myAxios
          .post(
            `/client_user/ApplyRefund/v1?username=${this.username}&orderId=${id}&reason=${this.reason}`
          )
          .then(res => {
            if (res.code == 0) {
              this.$alert(res.data, "提示", {
                confirmButtonText: "确定"
              }).then(() => {
                this.dialogVisible2 = false;
                this.dialogVisible3 = false;
                this.changeData("", "", "", "");
                this.$parent.$parent.$parent.getNums();
                setTimeout(() => {
                  this.getNum();
                }, 1000);
              });
            } else {
              this.dialogVisible3 = false;
              this.$alert(res.message, "提示", {
                confirmButtonText: "确定"
              });
            }
          });
      }
    },
    sumbit_finish() {
      myAxios
        .post(
          `/client_user/ConfirmFinish/v1?username=${this.username}&orderId=${this.detail.id}`
        )
        .then(res => {
          if (res.code == 0) {
            this.$alert(res.data, "提示", {
              confirmButtonText: "确定"
            }).then(() => {
              this.$parent.$parent.$parent.getNums();
              setTimeout(() => {
                this.getNum();
              }, 1000);
              this.dialogVisible = false;
            });
          } else {
            this.$alert(res.message, "提示", {
              confirmButtonText: "确定"
            });
          }
        });
    },
    tuikuanyuanyin(Reason) {
      this.$alert(Reason, "拒绝退款原因", {
        confirmButtonText: "确定"
      });
    },
    tuikuanyuanyin2(Reason) {
      this.$alert(Reason, "拒绝收稿原因", {
        confirmButtonText: "确定"
      });
    }
  }
};
</script>

<style lang="less">
@import "../style/mixin";

.table_container {
  padding: 20px;
}

.man-cell {
  width: 200px;
  float: left;
  margin-right: 20px;
}

.red {
  background: #ff2424;
  padding-left: 5px;
  padding-right: 5px;
  border-radius: 10px;
  font-size: 8px;
  color: #ffffff;
}
</style>
